import { Component, CUSTOM_ELEMENTS_SCHEMA, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IIroNamRequest } from '@shs-digi-care-monorepo/interfaces';
import {
    TableComponent,
    TableHeadComponent,
    TableHeaderComponent,
    TableRowComponent,
    TableCellComponent,
    RequestsStatusPillComponent,
    MobileRowFieldComponent,
    MobileTableCardComponent,
    MobileTableComponent,
    SortOrder,
    statusPillColorMap
} from '@shs-digi-care-monorepo/frontend-lib';
import { TableDateCellComponent } from '../table-date-cell/table-date-cell.component';
import { TabFilterState } from '../../state/tab-filter-state';

@Component({
    selector: 'app-my-response-needed-table',
    templateUrl: './my-response-needed-table.component.html',
    imports: [
        RouterModule,
        TranslateModule,
        TableComponent,
        TableHeadComponent,
        TableHeaderComponent,
        TableRowComponent,
        TableCellComponent,
        RequestsStatusPillComponent,
        MobileRowFieldComponent,
        MobileTableCardComponent,
        MobileTableComponent,
        TableDateCellComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MyResponseNeededTableComponent {
    public tasks = input.required<IIroNamRequest[]>();
    public loading = input.required<boolean>();
    public total = input.required<number>();
    public activeState = input.required<TabFilterState>();

    public sortChange = output<{ column: string; order: SortOrder | null }>();

    protected statusPillColorMap = statusPillColorMap;
}
